export const RateLimitTestIdFactory = {
    getRateLimitBase: () => 'rate-limit',
    getRateLimitInputBase: () => [RateLimitTestIdFactory.getRateLimitBase(), 'input'].join('-'),
    getRateLimitUnitBase: () => [RateLimitTestIdFactory.getRateLimitBase(), 'unit'].join('-'),
    getRateLimitTestId: (scope, type) => [scope, type, RateLimitTestIdFactory.getRateLimitBase()].join('-'),
    getRateLimitUnitTestId: (scope, type) => [scope, type, RateLimitTestIdFactory.getRateLimitUnitBase()].join('-'),
};
